module.exports = "/assets/data/20a82d9284ff8adc6be43f0ef915710b-AB12.data.json";